import { HttpErrorResponse } from '@angular/common/http';
import { IPersonDTO } from '@modeso/types__aumico-lib-companies-be';
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { IPersonExportDto } from '../dtos/person-export-dto.interface';
import { IPersonExportTableHeaders } from '../dtos/person-export-table-header-dto.interface';
import { PersonsFilter } from '../interfaces/persons-filter.interface';
import { PersonBulkUpdate } from '../services/persons.service';
import { TasksUpdate } from '../enums/tasks-update.enum';

// REV-22155 — persons in the mandate management. Per action: start, success, failure.

// **Get Persons */
export const getPersons = createAction('[Aumico-Persons] getPersons');
export const onGettingPersonsSuccessfully = createAction(
    '[Aumico-Persons] onGettingPersonsSuccessfully',
    props<{ payload: IPersonDTO[] }>(),
);
export const onGettingPersonsFailed = createAction(
    '[Aumico-Persons] onGettingPersonsFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Get Persons linked to a company ("Verknüpfte Personen" in the company profile) */
export const getPersonsOfCompany = createAction('[Aumico-Persons] getPersonsOfCompany', props<{ companyId: string }>());
export const onGettingPersonsOfCompanySuccessfully = createAction(
    '[Aumico-Persons] onGettingPersonsOfCompanySuccessfully',
    props<{ payload: IPersonDTO[] }>(),
);
export const onGettingPersonsOfCompanyFailed = createAction(
    '[Aumico-Persons] onGettingPersonsOfCompanyFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Get Person by id */
export const getPersonById = createAction('[Aumico-Persons] getPersonById', props<{ id: string }>());
export const onGettingPersonByIdSuccessfully = createAction(
    '[Aumico-Persons] onGettingPersonByIdSuccessfully',
    props<{ payload: IPersonDTO }>(),
);
export const onGettingPersonByIdFailed = createAction(
    '[Aumico-Persons] onGettingPersonByIdFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Create Person */
export const createPerson = createAction('[Aumico-Persons] createPerson', props<{ person: IPersonDTO }>());
export const onCreatePersonSuccessfully = createAction(
    '[Aumico-Persons] onCreatePersonSuccessfully',
    props<{ payload: IPersonDTO }>(),
);
export const onCreatePersonFailed = createAction(
    '[Aumico-Persons] onCreatePersonFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Update Person */
export const updatePerson = createAction(
    '[Aumico-Persons] updatePerson',
    props<{ person: IPersonDTO; tasksUpdate?: TasksUpdate }>(),
);
export const onUpdatePersonSuccessfully = createAction(
    '[Aumico-Persons] onUpdatePersonSuccessfully',
    props<{ payload: IPersonDTO }>(),
);
export const onUpdatePersonFailed = createAction(
    '[Aumico-Persons] onUpdatePersonFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Change Person Status */
export const changePersonStatus = createAction(
    '[Aumico-Persons] changePersonStatus',
    props<{ id: string; active: boolean }>(),
);
export const onChangePersonStatusSuccessfully = createAction(
    '[Aumico-Persons] onChangePersonStatusSuccessfully',
    props<{ payload: IPersonDTO }>(),
);
export const onChangePersonStatusFailed = createAction(
    '[Aumico-Persons] onChangePersonStatusFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Delete Person */
export const deletePerson = createAction('[Aumico-Persons] deletePerson', props<{ id: string }>());
export const onDeletePersonSuccessfully = createAction(
    '[Aumico-Persons] onDeletePersonSuccessfully',
    props<{ id: string }>(),
);
export const onDeletePersonFailed = createAction(
    '[Aumico-Persons] onDeletePersonFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Bulk Update Persons (Mandatsleiter / Sachbearbeiter) */
export const bulkUpdatePersons = createAction(
    '[Aumico-Persons] bulkUpdatePersons',
    props<{ persons: PersonBulkUpdate[]; tasksUpdate?: TasksUpdate }>(),
);
export const onBulkUpdatePersonsSuccessfully = createAction(
    '[Aumico-Persons] onBulkUpdatePersonsSuccessfully',
    props<{ payload: IPersonDTO[] }>(),
);
export const onBulkUpdatePersonsFailed = createAction(
    '[Aumico-Persons] onBulkUpdatePersonsFailed',
    props<{ payload: HttpErrorResponse }>(),
);

// **Overview filter — remembered so it is still set after profile → back */
export const setPersonsFilter = createAction('[Aumico-Persons] setPersonsFilter', props<{ filter: PersonsFilter }>());

export const resetPersons = createAction('[Aumico-Persons] resetPersons');
export const resetPersonsErrors = createAction('[Aumico-Persons] resetPersonsErrors');

export const exportPersonsDataAsExcel = createActionGroup({
    source: '[Aumico-Persons] Export Persons Data As Excel',
    events: {
        do: props<{
            payload: { tableHeaders: IPersonExportTableHeaders; persons: IPersonExportDto[]; fileName: string };
        }>(),
        success: emptyProps(),
        failed: props<{ payload: HttpErrorResponse }>(),
    },
});
